






















































































































































































































































import {
  defineComponent,
  SetupContext,
  PropType,
  ref,
  computed,
} from '@nuxtjs/composition-api';
import { Post, BookmarkType } from '@/graphql/graphqlOperations';
import useAppRoute from '~/compositions/useAppRoute';
import { useDayjs } from '~/compositions/useUtils';

export default defineComponent({
  props: {
    feed: {
      type: Object as PropType<Post>,
      required: true,
    },
    showBookmark: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, _context: SetupContext) {
    const bookmark = ref(props.feed.bookmark);
    const { URLs } = useAppRoute();
    const detailUrl = URLs.show_feed_with_id(props.feed.feedId);
    const isSys = !props.feed.corporation?.id;
    const dayjs = useDayjs();
    // 今日
    // const today = dayjs().startOf('day').format('YYYY/MM/DD hh:mm:ss');
    const now = dayjs().format('YYYY/MM/DD hh:mm:ss');

    // 投稿日
    const feedCreatedTime = ref(
      dayjs(props.feed.createdAt).format('YYYY/MM/DD hh:mm:ss')
    );

    const aria_label = computed(() => props.feed.title);
    return { detailUrl, BookmarkType, bookmark, isSys, aria_label };
  },
});
